<template>
  <a-collapse
    v-for="(item, index) in items"
    :key="index"
    v-model:active-key="activeKeys[index]"
    class="collapse"
    expand-icon-position="right"
    :bordered="false"
  >
    <a-collapse-panel
      v-for="child in item.children"
      :key="child.key"
    >
      <slot :name="child.key" />
      <template #header>
        <a-space>
          <IconFont
            v-if="child.icon"
            :type="child.icon"
            :style="{ fontSize: '18px' }"
          />
          <span :style="{ fontWeight: 'bold' }">
            {{ child.title }}
          </span>
          <span>{{ child.afterTitle }}</span>
        </a-space>
      </template>
    </a-collapse-panel>
  </a-collapse>
</template>
<script>
import { ref } from 'vue'
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup (props) {
    const activeKeys = ref([])
    props.items.forEach(item => {
      activeKeys.value.push(item.activeKey)
    })
    return {
      activeKeys
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.ant-collapse-header) {
  display: flex;
  align-items: center;
  padding: 12px 0 0 0;
  .ant-collapse-arrow {
    margin-left: 8px;
    position: static !important;
    order: 2;
    transform: none !important;
  }
}
.collapse {
  border-radius: 8px;
  background-color: transparent;
  :deep(.ant-collapse-header) {
    padding: 12px 2px;
  }
  :deep(.ant-collapse-content-box) {
    padding: 4px 2px;
  }
  :deep(.ant-collapse-item) {
    border: none;
  }
  & + .collapse {
    margin-top: 16px;
  }
}
</style>
